import importerReducers from 'src/modules/shared/importer/importerReducers';
import { ListedCompanyImporterActions, UnlistedCompanyImporterActions } from 'src/modules/company/importer/companyImporterActions';

export const listedImporterReducer = importerReducers(ListedCompanyImporterActions);
export const unlistedImporterReducer = importerReducers(UnlistedCompanyImporterActions);
